export const toDecimal = (value: number, decimal: number, callback: (v: number) => number) => {
  const factor = Math.pow(10, Math.max(decimal || 0, 0));
  return callback(value * factor) / factor;
};

export const roundToDecimal = (value: number, decimal: number) => toDecimal(value, decimal, (v) => Math.round(v));

export const floorToDecimal = (value: number, decimal: number) => toDecimal(value, decimal, (v) => Math.floor(v));
